export default "__VITE_ASSET__9bff48bb__"